'use client';

import { Button } from '@/components/ui/button';
import { EmptyState, type EmptyStateLevel } from '@/components/ui/empty-state';

// What a list shows when its data failed to load, in place of its empty state.
//
// Falling through to the empty state after a failed read tells the user
// something false about their account ("No payments yet") when the truth is
// about the read. On a page about money that reads as "your purchases are gone",
// which is the worst thing it could say. Same wording as the inbox's own error
// state on /dashboard/messages.
export function LoadErrorState({
  title,
  as,
  className,
}: {
  /** Names what failed, e.g. "Your payment history couldn't load". */
  title: string;
  as?: EmptyStateLevel;
  className?: string;
}) {
  return (
    <EmptyState
      role="alert"
      as={as}
      className={className}
      title={title}
      message="Check your connection, then try again."
      action={
        <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
          Try again
        </Button>
      }
    />
  );
}
